function Inquiry({ presetMessages = [], onPresetClick }) {
  return (
    <div className="p-1 bg-gray-100 rounded-lg ">
      <h3 className="text-lg font-semibold mb-3 text-[--color--1]">Quick Replies</h3>
      {presetMessages.length === 0 ? (
        <div className="text-gray-400 text-sm">No preset messages available.</div>
      ) : (
        <div className="flex flex-wrap gap-2 max-h-96 pr-2 overflow-auto ">
          {presetMessages.map((msg) => (
            <button
              key={msg._id}
              className="px-4 py-2 bg-white border border-[--color--1] text-[--color--1] rounded-full shadow-sm hover:bg-[--color--1] transition-colors duration-150 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[--color--1]"
              onClick={() => onPresetClick(msg.message)}
              title={msg.message}
            >
              {msg.message.length > 40 ? msg.message.slice(0, 40) + '…' : msg.message}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default Inquiry;
